<template>
    <div>
        <div>
            <div colspan="7" class="title" style="text-align: center;">机械需求申请单</div>
            <div class="flex" style="justify-content: space-between;width: 85%;">
                <div style="width: 10%;white-space: nowrap;">项目名称: {{ (form.data.project_name!=undefined)?form.data.project_name:"--" }}</div>
                <div style="width: 10%;white-space: nowrap;">时间: {{ form.create_time }}</div>
            </div>

            <table class="payment-table">
            <!-- 第一行 标题 -->
 
            <!-- 第三行 -->
            <tr>
                <td colspan="1" class="table-tr-title">申请部门</td>
                <td colspan="4" class="center">{{ (form.data.depart_name!=undefined)?form.data.depart_name:"--" }}</td>
                <td colspan="1" class="center" style="width: 10%;">申请人</td>
                <td colspan="2" class="center">{{ (form.data.apply_name!=undefined)?form.data.apply_name:"--" }}</td>
            </tr>

            <tr>
                <td colspan="1" rowspan="2" class="table-tr-title">付款内容</td>
                <td colspan="1" class="center" style="width: 10%;">汽车吊/随车吊</td>
                <td colspan="1" class="center" style="width: 10%;">吨</td>
                <td colspan="1" rowspan="2" class="center" style="width: 10%;">预计使用数量</td>
                <td colspan="1" class="center" style="text-align: right;width: 10%;">{{ (form.data.amount!=undefined)?form.data.amount:"--" }} 小时</td>
                <td colspan="1" rowspan="2" class="center" style="width: 10%;">是否涉及交叉扣款</td>
                <td colspan="2" rowspan="2" class="center"> {{ (form.data.cross_charge!=undefined)?form.data.cross_charge:"--" }} </td>
            </tr>

            <tr>
                <td colspan="1" class="table-tr-title">塔吊</td>
                <td colspan="1" class="center" style="width: 10%;">{{ (form.data.machine_name!=undefined)?form.data.machine_name:"--" }} </td>
                <td colspan="1" class="center" style="text-align: right;width: 10%;">小时</td>
            </tr>

            <tr>
                <td colspan="1" class="table-tr-title">开始使用时间</td>
                <td colspan="3" class="center">{{ (form.data.start_date!=undefined)?form.data.start_date:"--" }}</td>
                <td colspan="1" class="table-tr-title">预估中止时间</td>
                <td colspan="3" class="center">{{ (form.data.end_date!=undefined)?form.data.end_date:"--" }}</td>
            </tr>

            <tr>
                <td colspan="1" class="table-tr-title">工作部位</td>
                <td colspan="3" class="center">{{ (form.data.place!=undefined)?form.data.place:"--" }}</td>
                <td colspan="1" style="width: 10%;font-weight: bold;font-size: 12px;">甲方指令单或货联系单编号</td>
                <td colspan="3" class="center">{{ (form.data.series!=undefined)?form.data.series:"--" }}</td>
            </tr>

            <tr>
                <td colspan="1" class="table-tr-title">工作内容</td>
                <td colspan="7" class="center">{{ (form.data.message!=undefined)?form.data.message:"--" }}</td>
            </tr>

            <tr>
                <td colspan="1" class="table-tr-title">生产经理审批</td>
                <td colspan="3" class="center"></td>
                <td colspan="1" style="width: 10%;font-weight: bold; font-size: 12px;">项目经理审批</td>
                <td colspan="3" class="center"></td>
            </tr>
            </table>
        </div>
    </div>
</template>
<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN'

export default {
    name: "PaymentTable",
    props:{
        form:{
            type:Object
        }
    },
    data() {
        return {
            locale,
            select_column:{},
			dateFormat: 'yyyy-MM-dd HH:mm:ss',
        }
    },
    created() {
        this.updateTime()
        console.log(this.form)
    },
    methods: {
        updateTime(){
            const timestamp1 = this.form.data.start_time; // Unix时间戳
            const date1 = new Date(timestamp1);

            const year1 = date1.getFullYear();
            const month1 = String(date1.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1，然后确保两位数字
            const day1 = String(date1.getDate()).padStart(2, '0');
            const hours1 = String(date1.getHours()).padStart(2, '0');
            const minutes1 = String(date1.getMinutes()).padStart(2, '0');
            const seconds1 = String(date1.getSeconds()).padStart(2, '0');
            this.form.data.start_time = `${year1}-${month1}-${day1} ${hours1}:${minutes1}:${seconds1}`;

            const timestamp2 = this.form.data.end_time; // Unix时间戳
            const date2 = new Date(timestamp2);

            const year2 = date2.getFullYear();
            const month2 = String(date2.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1，然后确保两位数字
            const day2 = String(date2.getDate()).padStart(2, '0');
            const hours2 = String(date2.getHours()).padStart(2, '0');
            const minutes2 = String(date2.getMinutes()).padStart(2, '0');
            const seconds2 = String(date2.getSeconds()).padStart(2, '0');
            this.form.data.end_time = `${year2}-${month2}-${day2} ${hours2}:${minutes2}:${seconds2}`;
            this.form.data.show_date = this.formatDate(this.form.data.date )
        },
        formatDate(dateString) {
            const date = new Date(dateString);
            const year = date.getFullYear();
            const month = date.getMonth() + 1; // getMonth() 返回0-11，所以需要+1
            const day = date.getDate();
            return `${year}年${month}月${day}日`;
        },
        handleOpenChange(open) {
            console.log('open', open);
            // this.open = open;
        },
 
    }
}
</script>

<style>
.ant-tree-title {
    font-size: 12px;
}
/* 添加一些基本的边框和样式 */  
table {  
    width: 100%;  
    border-collapse: collapse; /* 使边框合并 */  
}  
  
th, td {  
    border: 1px solid #ddd; /* 添加边框 */  
    padding: 8px; /* 添加内边距 */  
    text-align: center; /* 文本左对齐 */  
}  
  
.payment-table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
}

.payment-table th,
.payment-table td {
  border: 1px solid #000;
  padding: 10px;
  text-align: center;
}

.title {
  text-align: center;
  font-weight: bold;
  font-size: 18px;
  padding: 20px 0;
}

.row-2 {
  padding: 10px;
}

.row-content {
  display: flex;
  justify-content: space-between; /* 左中右分布 */
}

.row-content .left {
  text-align: left;
}

.row-content .center {
  text-align: center;
  flex-grow: 1; /* 使其在空间上居中 */
}

.row-content .right {
  text-align: right;
}

.left, .center, .right {
  width: 25%;
  font-weight: bold;
  font-size: 12px;
}
.table-tr-title{
  width: 10%;
  font-weight: bold;
  font-size: 12px;
}
</style>